/**
 * Schedule / Maintenance refresh windows for Control Centre.
 *
 * Keep in lockstep with zeecore:
 * - `OUTSTANDING_LOOKBACK_DAYS` (projection)
 * - `AQUARIUS_OVERDUE_LOOKBACK_DAYS` / `AQUARIUS_UPCOMING_LOOKAHEAD_DAYS` (ingest)
 */
export const MAINTENANCE_SCHEDULE_HISTORY_DAYS = 90;
export const MAINTENANCE_SCHEDULE_UPCOMING_DAYS = 90;

/** Chunk size for Control Centre Aquarius maintenance windowed catch-up. */
export const MAINTENANCE_REFRESH_WINDOWED_CHUNK_DAYS = 30;
